import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';

interface PCTabNavProps {
    navList: any    // 导航列表数据
    navClick: Function  // 导航点击事件
    boxWidth?: any   // 导航所占宽度，默认100%
    zIndex?: number // 导航显示层级，默认为10 
    isAlignLeft?: any   // 是否居左
    boxStylesData?: any // 导航最外层父级盒子自定义样式
    currentIndex?: number  // 当前点击的索引，默认为0，第一个被选中
    showFoldMenu?: any  // 是否显示折叠按钮，默认为false
    foldBgColor?: any //折叠按钮背景色，默认透明
    showAlias?: any // 是否显示别名
    showRightCornerNum?: boolean    // 是否显示右上角数量
}
interface H5TabNavState {
    navFoldStatus: any
    currentInd: any
}

@inject('app', 'site', 'user')
@observer
class PCTabNav extends React.Component<PCTabNavProps> {
    state: H5TabNavState = {
        navFoldStatus: false,
        currentInd: 0,  // 当前索引，当索引为0时，左侧渐变层不显示
    };
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        let { navList, currentIndex = 0, boxStylesData, showFoldMenu = false, foldBgColor, isAlignLeft, showAlias, showRightCornerNum = false } = this.props;
        let { navFoldStatus, currentInd } = this.state;
        let navLength = navList?.length; // 数组长度
        // 正确的 style 对象
        return <>
            <div className={styles.navBox} style={boxStylesData}>
                {/* {navList?.length > 3 && <div className={styles.navFilter}>
                    {currentInd !== 0 && <div className={styles.navFilterLeft}></div>}
                    <div className={styles.navFilterRight}></div>
                </div>} */}
                <div className={classNames(styles.navList, (isAlignLeft || navLength > 4) ? styles.navBoxLeft : '')} style={{flexWrap: navFoldStatus ? 'wrap' : 'nowrap'}}>
                    {navList?.map((item:any, index:any) => {
                        return <div key={index} className={classNames(styles.navItem, currentIndex == index ? styles.navActive : '')}>
                            <div className={styles.name}>{showAlias && item.associatedAlias ? item.associatedAlias : item.name}</div>
                            {(showRightCornerNum && item.num > 0) && <div className={styles.num}>{item.num}</div>}
                            <div className={styles.navCover} onClick={() => {
                                // console.log('点击');
                                this.setState({
                                    currentInd: index
                                })
                                this.props.navClick && this.props.navClick(item, index)
                            }}></div>
                        </div>
                    })}
                    {showFoldMenu && <img src={!navFoldStatus ? `${BASE_IMG_URL}/common/menu.png` : `${BASE_IMG_URL}/common/arrow_t1.png`}
                    alt=""
                    style={{background: foldBgColor ? foldBgColor : ''}}
                    className={styles.foldIcon}
                    onClick={()=> {
                        this.setState({
                            navFoldStatus: !navFoldStatus
                        })
                    }}/>}
                </div>
            </div>
        </>;
        
    }
}

export default PCTabNav;